import classNames from 'classnames';
import * as React from 'react';
import { ButtonActionSubtle } from '../ButtonAction/ButtonAction.js';
import { Icon } from '../Icon/Icon.js';

/* eslint-disable */
var TooltipContainer = props => {
  var {
    displayRight,
    displayTop,
    handleContentFocus,
    handleCloseButtonClick,
    handleCloseButtonKeyDown,
    mobileClass,
    surfaceRef,
    textRef,
    text,
    visible
  } = props;
  var tooltipClassName = classNames('tooltip__content', mobileClass, {
    'tooltip__content--top': displayTop && !displayRight
  }, {
    'tooltip__content--bottom': !displayTop && !displayRight
  }, {
    'tooltip__content--top__right': displayTop && displayRight
  }, {
    'tooltip__content--bottom__right': !displayTop && displayRight
  }, {
    'tooltip__content--show': visible
  }, {
    'tooltip__content--hide': !visible
  });
  return /*#__PURE__*/React.createElement("span", {
    className: tooltipClassName,
    ref: surfaceRef,
    tabIndex: -1,
    onFocus: handleContentFocus,
    hidden: !visible,
    "data-hcid": "tooltip-".concat("10.6.2")
  }, /*#__PURE__*/React.createElement("span", {
    className: "tooltip__content--text",
    ref: textRef
  }, text), /*#__PURE__*/React.createElement(ButtonActionSubtle, {
    className: "close-button",
    onClick: handleCloseButtonClick,
    onKeyDown: handleCloseButtonKeyDown,
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(Icon, {
    symbol: "controlClose24",
    type: "svginline"
  })));
};
var TooltipContainer$1 = TooltipContainer;

export { TooltipContainer$1 as default };
